var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-200 font-serif"},[_c('HeaderNavAFA',{attrs:{"titlelink":'/remixer',"ctatitle":'Go Back',"ctalink":'/'}}),_c('RemixerAppAFA')],1)}
var staticRenderFns = []

export { render, staticRenderFns }